import { YoutubeAPIService } from '../services';

const youtubeApiService = new YoutubeAPIService();

export const getChannelId = async (access_token) => {
  try {
    const youtubeResponse = await youtubeApiService.getChannelData(access_token);
    return youtubeResponse?.items?.[0].id;
  } catch (error) {
    return false
  }
}
